// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/about-us": [47],
		"/admin": [48,[6]],
		"/admin/appsettings": [49,[6]],
		"/admin/case-management": [50,[6]],
		"/admin/extensions": [51,[6]],
		"/admin/operations": [52,[6]],
		"/admin/roles": [53,[6]],
		"/admin/submissions": [54,[6]],
		"/admin/vehicle-reports": [55,[6]],
		"/contact-us": [56],
		"/location": [57],
		"/portal": [58,[7]],
		"/portal/cases": [59,[7]],
		"/portal/submissions": [60,[7]],
		"/practice-areas": [61],
		"/privacy-policy": [62],
		"/testimonials": [63],
		"/tos": [64],
		"/[lang]": [9],
		"/[lang]/about-us": [29],
		"/[lang]/admin": [30,[4]],
		"/[lang]/admin/appsettings": [31,[4]],
		"/[lang]/admin/case-management": [32,[4]],
		"/[lang]/admin/extensions": [33,[4]],
		"/[lang]/admin/operations": [34,[4]],
		"/[lang]/admin/roles": [35,[4]],
		"/[lang]/admin/submissions": [36,[4]],
		"/[lang]/admin/vehicle-reports": [37,[4]],
		"/[lang]/contact-us": [38],
		"/[lang]/location": [39],
		"/[lang]/portal": [40,[5]],
		"/[lang]/portal/cases": [41,[5]],
		"/[lang]/portal/submissions": [42,[5]],
		"/[lang]/practice-areas": [43],
		"/[lang]/privacy-policy": [44],
		"/[lang]/testimonials": [45],
		"/[lang]/tos": [46],
		"/[lang]/[area]": [10],
		"/[lang]/[area]/about-us": [11],
		"/[lang]/[area]/admin": [12,[2]],
		"/[lang]/[area]/admin/appsettings": [13,[2]],
		"/[lang]/[area]/admin/case-management": [14,[2]],
		"/[lang]/[area]/admin/extensions": [15,[2]],
		"/[lang]/[area]/admin/operations": [16,[2]],
		"/[lang]/[area]/admin/roles": [17,[2]],
		"/[lang]/[area]/admin/submissions": [18,[2]],
		"/[lang]/[area]/admin/vehicle-reports": [19,[2]],
		"/[lang]/[area]/contact-us": [20],
		"/[lang]/[area]/location": [21],
		"/[lang]/[area]/portal": [22,[3]],
		"/[lang]/[area]/portal/cases": [23,[3]],
		"/[lang]/[area]/portal/submissions": [24,[3]],
		"/[lang]/[area]/practice-areas": [25],
		"/[lang]/[area]/privacy-policy": [26],
		"/[lang]/[area]/testimonials": [27],
		"/[lang]/[area]/tos": [28]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);